/* @jsxImportSource @emotion/react */
import MaskLoading from '@/components/Loading/MaskLoading';
import { useStore } from '@/stores';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Container } from './styled';
import UnAuthentService from '@/services/UnAuthentService';
import UnAuthentStore from '@/stores/UnAuthentStore';
import { useLocation } from 'react-router-dom';
import { usePush } from '../Common/hook';
import UseErrorBlock from '@/components/commonComps/Use/UseErrorBlock';
import { getUrlVal } from '@/utils/utils';
const Page = () => {
  const { replaceUrl } = usePush(false);
  const unAuthentStore = useStore('UnAuthentStore') as typeof UnAuthentStore;
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const { pathname } = useLocation();
  const code = getUrlVal('code');
  console.log('pathname:', pathname);
  useEffect(() => {
    let selectSubSystemCode = getUrlVal('selectSubSystemCode') || '';
    let topath = pathname === '/' || !selectSubSystemCode ? '/Home' : pathname;
    if (!!code) {
      setLoading(true);
      UnAuthentService.scanCodeAuthenticate(code)
        .then((result) => {
          console.log('result:', result);
          const appSystem = (result.subSystemList || []).filter(
            (item) => item.appPlatforms?.includes('H5') && !!item.hasPermission
          );
          if (
            appSystem.length <= 0 ||
            (!!selectSubSystemCode && !appSystem.find((f) => f.code === selectSubSystemCode))
          ) {
            setErrorMsg('您没有系统权限，如需要相关系统权限，请在OA发起申请');
            return;
          }
          if (appSystem.length === 1 && !selectSubSystemCode) {
            selectSubSystemCode = appSystem[0].code;
            topath = (appSystem[0].phoneBaseUrl || '/') + (appSystem[0].homeUrl || '/');
          }
          let storageContext = {
            appSystem,
            userId: result.userId,
            userName: result.userName,
            xc: code,
            token: result.accessToken,
          };
          sessionStorage.setItem('userId', result.userId + '');
          localStorage.setItem('storageContext', JSON.stringify(storageContext));
          localStorage.setItem('selectSubSystemCode', selectSubSystemCode);
          // 设置头验证信息
          const headerAuthInfo = {
            accessToken: result.redisToken || '',
            Authorization: result.accessToken || '',
            'User-Id': String(result.userId) || '',
            'Login-Type': 'WECOM',
          };
          sessionStorage.setItem('headerAuthInfo', JSON.stringify(headerAuthInfo));

          unAuthentStore.setIsLogin(true);
          replaceUrl(topath);
        })
        .catch((error) => {
          console.log('error:', error);
          setErrorMsg(error + '');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setErrorMsg('请从企业微信-工作台访问应用');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container>
      <MaskLoading visible={loading} />
      {!!errorMsg ? <UseErrorBlock fullPage title={errorMsg} description="" /> : null}
    </Container>
  );
};
export default observer(Page);
